// Black Friday cosmetic pricing is now handled directly in PriceUI (z__jsProduct.js)
// This file is kept for any additional customizations if needed

// Black Friday cosmetic pricing for Recharge cart drawer
(function() {
  // Get discount multiplier based on product tags
  function getDiscountMultiplier(productTags) {
    if (!productTags) return 0.8;
    var tags = productTags.split(',').map(function(tag) { return tag.trim().toLowerCase(); });
    return tags.includes('kerwell') ? 0.7 : 0.8;
  }

  // Format money - try Shopify format, fallback to simple format
  function formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      try {
        return Shopify.formatMoney(cents, '{{ shop.money_format }}');
      } catch(e) {
        // Fallback
      }
    }
    // Fallback: simple format
    return '$' + (cents / 100).toFixed(2);
  }

  // Extract price in cents from formatted string
  function extractPriceCents(priceText) {
    if (!priceText) return null;
    // Remove HTML tags and extract number
    var cleanText = priceText.replace(/<[^>]*>/g, '').trim();
    // Try to match price patterns like $28.99, $28,99, 28.99, etc.
    var match = cleanText.match(/[\$]?[\d,]+\.?\d*/);
    if (!match) return null;
    var priceStr = match[0].replace(/[\$,]/g, '');
    var price = parseFloat(priceStr);
    if (isNaN(price)) return null;
    return Math.round(price * 100);
  }

  // Check if item is a subscription (has discount price element)
  function isSubscriptionItem(priceContainer) {
    // Check if there's a [part="money discount"] element in the same container
    var parent = priceContainer.closest('.text-right, [class*="line-item"], [class*="cart-item"]');
    if (!parent) return false;
    
    var discountPrice = parent.querySelector('[part="money discount"]');
    return discountPrice !== null;
  }

  // Apply cosmetic pricing to a single price element
  function applyCosmeticPricingToPrice(priceEl) {
    // Skip if already processed
    if (priceEl.hasAttribute('data-cosmetic-applied')) return false;
    
    // Check if this is part of a subscription item
    if (isSubscriptionItem(priceEl)) {
      return false; // Don't touch subscription items
    }
    
    // Get the parent container
    var priceContainer = priceEl.closest('.text-right');
    if (!priceContainer) return false;
    
    // Try to get product tags from the line item
    var lineItem = priceEl.closest('[data-line-item], [class*="line-item"], [class*="cart-item"]');
    var productTags = '';
    if (lineItem) {
      productTags = lineItem.getAttribute('data-product-tags') || '';
    }
    
    // Extract original price
    var priceText = priceEl.textContent || priceEl.innerText || '';
    var originalPriceCents = extractPriceCents(priceText);
    
    console.log('[Cosmetic Pricing] Price text:', priceText, 'Extracted cents:', originalPriceCents);
    
    if (!originalPriceCents) {
      console.log('[Cosmetic Pricing] Failed to extract price from:', priceText);
      return false;
    }
    
    // Calculate cosmetic price
    var discountMultiplier = getDiscountMultiplier(productTags);
    var cosmeticPriceCents = Math.round(originalPriceCents * discountMultiplier);
    
    // Mark as processed
    priceEl.setAttribute('data-cosmetic-applied', 'true');
    
    // Format prices
    var cosmeticPriceFormatted = formatMoney(cosmeticPriceCents);
    var originalPriceFormatted = formatMoney(originalPriceCents);
    
    // Update the price element
    priceEl.textContent = cosmeticPriceFormatted;
    
    // Add compare-at-price after the cosmetic price
    var compareAtPrice = document.createElement('span');
    compareAtPrice.className = 'text-storefront-drawer-muted line-through ml-2';
    compareAtPrice.style.marginLeft = '8px';
    compareAtPrice.style.textDecoration = 'line-through';
    compareAtPrice.style.opacity = '0.6';
    compareAtPrice.textContent = originalPriceFormatted;
    
    // Insert after the price element
    priceEl.parentNode.insertBefore(compareAtPrice, priceEl.nextSibling);
    
    return true;
  }

  // Helper to search in shadow DOM
  function searchInShadowDOM(root, selector) {
    var results = [];
    try {
      // Search in regular DOM
      var found = root.querySelectorAll(selector);
      results = Array.from(found);
      
      // Search in shadow DOMs
      var allElements = root.querySelectorAll('*');
      allElements.forEach(function(el) {
        if (el.shadowRoot) {
          var shadowFound = el.shadowRoot.querySelectorAll(selector);
          results = results.concat(Array.from(shadowFound));
          // Recursively search nested shadow DOMs
          var nested = searchInShadowDOM(el.shadowRoot, selector);
          results = results.concat(nested);
        }
      });
    } catch(e) {
      console.log('[Cosmetic Pricing] Error searching shadow DOM:', e);
    }
    return results;
  }

  // Apply cosmetic pricing to all cart items
  function applyCosmeticPricingToCartDrawer() {
    var cartDrawer = document.querySelector('#recharge-storefront-experiences__cart-drawer');
    if (!cartDrawer) {
      console.log('[Cosmetic Pricing] Cart drawer not found');
      return;
    }
    
    var innerHTMLLength = cartDrawer.innerHTML ? cartDrawer.innerHTML.length : 0;
    console.log('[Cosmetic Pricing] Cart drawer found, innerHTML length:', innerHTMLLength);
    
    // If drawer is empty, wait for content to load
    if (innerHTMLLength < 100) {
      console.log('[Cosmetic Pricing] Cart drawer appears empty, waiting for content...');
      return;
    }
    
    console.log('[Cosmetic Pricing] Searching for price elements...');
    
    // Try multiple selector variations - search in regular DOM and shadow DOM
    var selectors = [
      '.text-storefront-drawer-muted[part="money"]',
      '.text-storefront-drawer-muted',
      '[part="money"]',
      '[part="money"].text-storefront-drawer-muted',
      'span[part="money"]',
      '.text-storefront-drawer-muted span[part="money"]'
    ];
    
    var priceElements = [];
    for (var i = 0; i < selectors.length; i++) {
      var found = searchInShadowDOM(cartDrawer, selectors[i]);
      if (found.length > 0) {
        console.log('[Cosmetic Pricing] Found', found.length, 'elements with selector:', selectors[i]);
        priceElements = found;
        break;
      }
    }
    
    // If still no elements, try to find any element with the class
    if (priceElements.length === 0) {
      var allMuted = searchInShadowDOM(cartDrawer, '.text-storefront-drawer-muted');
      console.log('[Cosmetic Pricing] Found', allMuted.length, 'elements with .text-storefront-drawer-muted class');
      if (allMuted.length > 0) {
        // Log the first few to see their structure
        for (var j = 0; j < Math.min(3, allMuted.length); j++) {
          console.log('[Cosmetic Pricing] Element', j, ':', allMuted[j].outerHTML ? allMuted[j].outerHTML.substring(0, 200) : allMuted[j]);
          console.log('[Cosmetic Pricing] Element', j, 'text:', allMuted[j].textContent);
          console.log('[Cosmetic Pricing] Element', j, 'attributes:', Array.from(allMuted[j].attributes || []).map(function(a) { return a.name + '=' + a.value; }));
        }
        // Try to filter for price elements
        allMuted.forEach(function(el) {
          var text = el.textContent || el.innerText || '';
          if (text.includes('$') || text.match(/[\d,]+\.?\d*/)) {
            priceElements.push(el);
          }
        });
        console.log('[Cosmetic Pricing] Filtered to', priceElements.length, 'price-like elements');
      } else {
        // Last resort: search for any element containing a price pattern
        var allElements = cartDrawer.querySelectorAll('*');
        console.log('[Cosmetic Pricing] Searching', allElements.length, 'total elements in cart drawer');
        allElements.forEach(function(el) {
          var text = el.textContent || el.innerText || '';
          if (text.trim() && (text.includes('$') && text.match(/[\d,]+\.?\d*/))) {
            // Check if it looks like a price (not too long, contains $ and number)
            if (text.length < 20 && text.match(/\$[\d,]+\.?\d*/)) {
              priceElements.push(el);
            }
          }
        });
        console.log('[Cosmetic Pricing] Found', priceElements.length, 'potential price elements by text content');
      }
    }
    
    console.log('[Cosmetic Pricing] Processing', priceElements.length, 'price elements');
    
    priceElements.forEach(function(priceEl) {
      // Only process if it's not part of a subscription item
      if (!isSubscriptionItem(priceEl)) {
        var applied = applyCosmeticPricingToPrice(priceEl);
        if (applied) {
          console.log('[Cosmetic Pricing] Applied to price:', priceEl.textContent);
        }
      } else {
        console.log('[Cosmetic Pricing] Skipped subscription item');
      }
    });
  }

  // Watch for Recharge cart drawer updates
  var cartDrawerObserver = null;
  var priceUpdateInterval = null;

  function startCartDrawerMonitoring() {
    var cartDrawer = document.querySelector('#recharge-storefront-experiences__cart-drawer');
    if (!cartDrawer) return;
    
    // Clear existing observer
    if (cartDrawerObserver) {
      cartDrawerObserver.disconnect();
    }
    
    // Observe cart drawer for changes
    cartDrawerObserver = new MutationObserver(function(mutations) {
      var shouldUpdate = false;
      mutations.forEach(function(mutation) {
        if (mutation.addedNodes.length > 0) {
          // Check if added nodes have substantial content
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1) { // Element node
              var content = node.innerHTML || node.textContent || '';
              if (content.length > 50) {
                shouldUpdate = true;
              }
            }
          });
        }
        if (mutation.type === 'attributes' && 
            (mutation.attributeName === 'class' || mutation.attributeName === 'style')) {
          shouldUpdate = true;
        }
        // Also check if innerHTML changed significantly
        if (mutation.type === 'childList' && cartDrawer.innerHTML && cartDrawer.innerHTML.length > 100) {
          shouldUpdate = true;
        }
      });
      if (shouldUpdate) {
        setTimeout(function() {
          if (cartDrawer.innerHTML && cartDrawer.innerHTML.length > 100) {
            applyCosmeticPricingToCartDrawer();
          }
        }, 300);
      }
    });
    
    cartDrawerObserver.observe(cartDrawer, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style', 'hidden', 'data-*'],
      characterData: true
    });
    
    // Also use polling as backup (since Recharge loads dynamically)
    if (priceUpdateInterval) {
      clearInterval(priceUpdateInterval);
    }
    
    priceUpdateInterval = setInterval(function() {
      if (cartDrawer) {
        // Check if drawer has content (not just empty div)
        var hasContent = cartDrawer.innerHTML && cartDrawer.innerHTML.length > 100;
        var isVisible = cartDrawer.offsetParent !== null || 
                        cartDrawer.style.display !== 'none' ||
                        !cartDrawer.hasAttribute('hidden');
        
        if (hasContent && isVisible) {
          // Drawer is visible and has content
          applyCosmeticPricingToCartDrawer();
        }
      }
    }, 200); // More frequent polling to catch content loading
    
    // Initial apply - wait longer for Recharge to load
    setTimeout(function() {
      if (cartDrawer.innerHTML && cartDrawer.innerHTML.length > 100) {
        applyCosmeticPricingToCartDrawer();
      }
    }, 1000);
    
    // Also try after a longer delay
    setTimeout(function() {
      if (cartDrawer.innerHTML && cartDrawer.innerHTML.length > 100) {
        applyCosmeticPricingToCartDrawer();
      }
    }, 2000);
  }

  // Wait for Recharge cart drawer to load
  function waitForRechargeCartDrawer() {
    var maxAttempts = 20;
    var attempts = 0;
    
    var checkInterval = setInterval(function() {
      attempts++;
      var cartDrawer = document.querySelector('#recharge-storefront-experiences__cart-drawer');
      
      if (cartDrawer || attempts >= maxAttempts) {
        clearInterval(checkInterval);
        if (cartDrawer) {
          startCartDrawerMonitoring();
        }
      }
    }, 500);
  }

  // Listen for cart drawer open events
  function setupCartDrawerListeners() {
    // Watch for when cart drawer becomes visible
    var bodyObserver = new MutationObserver(function() {
      var cartDrawer = document.querySelector('#recharge-storefront-experiences__cart-drawer');
      if (cartDrawer && cartDrawer.offsetParent !== null) {
        // Drawer is visible, ensure monitoring is active
        if (!cartDrawerObserver) {
          startCartDrawerMonitoring();
        }
        setTimeout(applyCosmeticPricingToCartDrawer, 300);
      }
    });
    
    if (document.body) {
      bodyObserver.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'style']
      });
    }
  }

  // Initialize
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      waitForRechargeCartDrawer();
      setupCartDrawerListeners();
    });
  } else {
    waitForRechargeCartDrawer();
    setupCartDrawerListeners();
  }

  // Also listen for Recharge-specific events if they exist
  window.addEventListener('recharge:cart:updated', function() {
    setTimeout(applyCosmeticPricingToCartDrawer, 300);
  });

  window.addEventListener('recharge:cart:opened', function() {
    setTimeout(applyCosmeticPricingToCartDrawer, 300);
  });
})();

// Beverage free shipping messaging for Recharge cart drawer
// Primary: Config interception via Liquid (in shadow-dom-interceptor.liquid)
//   disables shipping_progress_bar.enabled BEFORE ReCharge initializes.
// Secondary (this file): handles dynamic cart updates (AJAX add/remove),
//   shadow DOM CSS injection, TreeWalker text hiding, and overlay message.
(function() {
  'use strict';
  var BEVERAGE_MSG = "At this time, we\u2019re unable to offer free shipping on orders that include beverages due to the additional shipping requirements.";
  var cache = { hasBeverage: null, ts: 0 };
  var CACHE_TTL = 2000;
  var _debounceTimer = null;

  // ── CSS to inject into shadow roots (broad selectors) ────────────
  var HIDE_SHIPPING_CSS = [
    '/* Beverage: hide shipping progress bar */',
    '[class*="shipping-progress" i] { display: none !important; }',
    '[class*="shipping_progress" i] { display: none !important; }',
    '[class*="shippingProgress" i] { display: none !important; }',
    '[class*="free-shipping" i] { display: none !important; }',
    '[class*="free_shipping" i] { display: none !important; }',
    '[class*="freeShipping" i] { display: none !important; }',
    '[class*="shipping-bar" i] { display: none !important; }',
    '[class*="shipping_bar" i] { display: none !important; }',
    '[class*="shippingBar" i] { display: none !important; }',
    '[part*="shipping" i] { display: none !important; }',
    '[part*="progress-bar" i] { display: none !important; }',
    '[part*="free-shipping" i] { display: none !important; }',
    '[data-shipping-progress] { display: none !important; }',
    '[data-free-shipping] { display: none !important; }',
    '[data-testid*="shipping" i] { display: none !important; }',
    '[data-testid*="progress" i] { display: none !important; }',
    '[data-bev-hidden="true"] { display: none !important; }'
  ].join('\n');

  // ── Cart beverage check (client-side, for dynamic updates) ───────
  function checkCart(cb) {
    var now = Date.now();
    if (cache.hasBeverage !== null && (now - cache.ts) < CACHE_TTL) {
      return cb(cache.hasBeverage);
    }
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        cache.hasBeverage = (cart.items || []).some(function(i) {
          return i.product_type === 'Beverage';
        });
        cache.ts = Date.now();
        cb(cache.hasBeverage);
      })
      .catch(function() { cb(false); });
  }

  function invalidateCache() {
    cache.hasBeverage = null;
    cache.ts = 0;
  }

  // ── Strategy 1: Toggle CSS in adopted stylesheets ────────────────
  function toggleAdoptedCSS(hide) {
    var css = hide ? HIDE_SHIPPING_CSS : '';
    if (window.__beverageSheets) {
      window.__beverageSheets.forEach(function(sheet) {
        try { sheet.replaceSync(css); } catch(e) {}
      });
    }
  }

  // ── Strategy 2: <style> fallback inside each shadow root ─────────
  function toggleStyleElements(hide) {
    if (!window.__shadowRoots) return;
    var STYLE_ID = '__bev_ship_css';
    window.__shadowRoots.forEach(function(sr) {
      try {
        var existing = sr.querySelector('#' + STYLE_ID);
        if (hide && !existing) {
          var s = document.createElement('style');
          s.id = STYLE_ID;
          s.textContent = HIDE_SHIPPING_CSS;
          sr.appendChild(s);
        } else if (!hide && existing) {
          existing.remove();
        }
      } catch(e) {}
    });
  }

  // ── Strategy 3: TreeWalker — find & hide shipping text in shadow ──
  function walkAndHide(hide) {
    if (!window.__shadowRoots) return;
    window.__shadowRoots.forEach(function(sr) {
      try { walkRoot(sr, hide); } catch(e) {}
    });
  }

  function walkRoot(root, hide) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null, false);
    var node;
    while (node = walker.nextNode()) {
      var t = (node.textContent || '').toLowerCase();
      if (
        t.includes('free shipping') ||
        t.includes('unlocked free shipping') ||
        (t.includes('spend') && t.includes('more for'))
      ) {
        var el = node.parentElement;
        if (!el) continue;
        // Don't hide our own beverage overlay message
        if (el.closest('[data-bev-overlay]')) continue;
        // Walk up to a reasonable container
        var container = el;
        for (var i = 0; i < 5; i++) {
          var p = container.parentElement || container.parentNode;
          if (!p || p === root || p.nodeType === 11) break;
          if (p.children && p.children.length > 3) break;
          container = p;
        }
        if (hide) {
          if (!container.hasAttribute('data-bev-hidden')) {
            container.setAttribute('data-bev-hidden', 'true');
            container.setAttribute('data-bev-orig-display', container.style.display || '');
            container.style.setProperty('display', 'none', 'important');
          }
        } else {
          if (container.hasAttribute('data-bev-hidden')) {
            container.style.display = container.getAttribute('data-bev-orig-display') || '';
            container.removeAttribute('data-bev-hidden');
            container.removeAttribute('data-bev-orig-display');
          }
        }
      }
    }
    // Recurse into nested shadow roots
    try {
      var els = root.querySelectorAll('*');
      els.forEach(function(el) {
        var nested = (window.__shadowRoots && window.__shadowRoots.has(el))
          ? window.__shadowRoots.get(el) : el.shadowRoot;
        if (nested) walkRoot(nested, hide);
      });
    } catch(e) {}
  }

  // ── Strategy 4: Modify ReCharge config (runtime) ─────────────────
  // The interceptor handles page-load; this covers dynamic AJAX changes
  function modifyConfig(hasBeverage) {
    try {
      var cfg = window.RechargeStorefrontConfig;
      if (cfg && cfg.cart_drawer && cfg.cart_drawer.config && cfg.cart_drawer.config.config) {
        var bar = cfg.cart_drawer.config.config.shipping_progress_bar;
        if (bar) bar.enabled = !hasBeverage;
      }
    } catch(e) {}
  }

  // ── Strategy 5: Overlay message ──────────────────────────────────
  // #cart-drawer lives INSIDE Recharge's Shadow DOM, so we must
  // search through captured shadow roots to find it.
  function createOverlayEl() {
    var el = document.createElement('div');
    el.setAttribute('data-bev-overlay', 'true');
    el.style.cssText = [
      'text-align:center', 'padding:10px 16px', 'background:#fef3cd',
      'border:1px solid #ffc107', 'border-radius:6px', 'margin:8px 16px',
      'font-size:13px', 'color:#856404', 'position:relative', 'z-index:999999'
    ].join(';');
    el.innerHTML = '<p style="margin:0">' + BEVERAGE_MSG + '</p>';
    return el;
  }

  // Search through all captured shadow roots to find #cart-drawer
  function findCartDrawerInShadow() {
    // 1. Try regular DOM first (just in case)
    var cd = document.querySelector('#cart-drawer');
    if (cd) return cd;

    // 2. Search captured shadow roots
    if (window.__shadowRoots) {
      var found = null;
      window.__shadowRoots.forEach(function(sr) {
        if (found) return;
        try {
          var el = sr.querySelector('#cart-drawer');
          if (el) found = el;
        } catch(e) {}
        // Also check nested shadow roots
        try {
          sr.querySelectorAll('*').forEach(function(child) {
            if (found) return;
            var nested = window.__shadowRoots.get(child) || child.shadowRoot;
            if (nested) {
              var el = nested.querySelector('#cart-drawer');
              if (el) found = el;
            }
          });
        } catch(e) {}
      });
      if (found) return found;
    }

    // 3. Try open shadow roots on Recharge elements
    var rcHost = document.querySelector('#recharge-storefront-experiences__cart-drawer');
    if (rcHost && rcHost.shadowRoot) {
      var el = rcHost.shadowRoot.querySelector('#cart-drawer');
      if (el) return el;
    }

    return null;
  }

  function updateOverlay(hasBeverage) {
    var cartDrawer = findCartDrawerInShadow();
    if (!cartDrawer) return;

    if (hasBeverage) {
      // Already injected? Skip
      if (cartDrawer.querySelector('[data-bev-overlay]')) return;

      // Insert at the top of the cart drawer
      var msg = createOverlayEl();
      cartDrawer.insertBefore(msg, cartDrawer.firstChild);
    } else {
      // Remove overlay
      var overlays = cartDrawer.querySelectorAll('[data-bev-overlay]');
      overlays.forEach(function(o) { o.remove(); });
    }
  }

  // ── Diagnostics ──────────────────────────────────────────────────
  var _diagRan = false;
  function runDiagnostics() {
    if (_diagRan || !window.__shadowRoots) return;
    _diagRan = true;
    console.log('[Beverage Shipping] Beverage in cart (Liquid):', window.__cartHasBeverage);
    console.log('[Beverage Shipping] Shadow roots captured:', window.__shadowRoots.size);
    var idx = 0;
    window.__shadowRoots.forEach(function(sr, host) {
      var tag = host.tagName || '?';
      var id = host.id || '';
      var cls = host.className || '';
      var htmlLen = 0;
      try { htmlLen = sr.innerHTML ? sr.innerHTML.length : 0; } catch(e) {}
      console.log('[Beverage Shipping] SR#' + idx + ' host:', tag + (id ? '#' + id : '') + (cls ? '.' + String(cls).split(' ').join('.') : ''), 'innerHTML:', htmlLen);
      // Log part attributes
      try {
        var parts = sr.querySelectorAll('[part]');
        if (parts.length) {
          parts.forEach(function(p) {
            console.log('[Beverage Shipping]   part="' + p.getAttribute('part') + '"', p.tagName, (p.textContent || '').substring(0, 60));
          });
        }
      } catch(e) {}
      // Content preview
      try {
        var preview = (sr.innerHTML || '').substring(0, 300);
        if (preview) console.log('[Beverage Shipping]   preview:', preview);
      } catch(e) {}
      idx++;
    });
    // Check for iframes
    var cd = document.querySelector('#cart-drawer')
          || document.querySelector('#recharge-storefront-experiences__cart-drawer');
    if (cd) {
      console.log('[Beverage Shipping] Iframes in cart drawer:', cd.querySelectorAll('iframe').length);
    }
    // Check config state
    try {
      var cfg = window.RechargeStorefrontConfig;
      if (cfg && cfg.cart_drawer && cfg.cart_drawer.config && cfg.cart_drawer.config.config) {
        var bar = cfg.cart_drawer.config.config.shipping_progress_bar;
        console.log('[Beverage Shipping] Config shipping_progress_bar:', JSON.stringify(bar));
      }
    } catch(e) {}
  }

  // ── Main update ──────────────────────────────────────────────────
  // No close/reopen cycle — config interception (shadow-dom-interceptor.liquid)
  // handles initial load; CSS/TreeWalker strategies handle dynamic updates;
  // config changes take full effect on next drawer open.
  function update() {
    runDiagnostics();
    checkCart(function(hasBeverage) {
      window.__cartHasBeverage = hasBeverage;
      toggleAdoptedCSS(hasBeverage);
      toggleStyleElements(hasBeverage);
      walkAndHide(hasBeverage);
      modifyConfig(hasBeverage);
      updateOverlay(hasBeverage);
    });
  }

  function debouncedUpdate() {
    clearTimeout(_debounceTimer);
    _debounceTimer = setTimeout(update, 200);
  }

  // ── Monitoring ───────────────────────────────────────────────────
  var _drawObs = null;
  var _prevSRCount = 0;
  var _drawerPollInterval = null;

  // Poll /cart.js to catch ALL cart changes regardless of what
  // API endpoint ReCharge uses internally (their remove endpoint
  // is NOT a standard Shopify /cart/* URL)
  function startDrawerPolling() {
    if (_drawerPollInterval) return;
    _drawerPollInterval = setInterval(function() {
      invalidateCache();
      update();
    }, 1500);
  }

  function startMonitoring() {
    // Observe both the actual cart drawer and the Recharge wrapper
    var cd = document.querySelector('#cart-drawer')
          || document.querySelector('#recharge-storefront-experiences__cart-drawer');
    if (cd && !_drawObs) {
      _drawObs = new MutationObserver(debouncedUpdate);
      _drawObs.observe(cd, { childList: true, subtree: true });
    }

    // React to shadow root content changes
    window.addEventListener('__shadowMutation', debouncedUpdate);

    // Watch for new shadow roots (lazy creation)
    _prevSRCount = window.__shadowRoots ? window.__shadowRoots.size : 0;
    setInterval(function() {
      var cur = window.__shadowRoots ? window.__shadowRoots.size : 0;
      if (cur > _prevSRCount) {
        _prevSRCount = cur;
        _diagRan = false;
        update();
      }
    }, 1000);

    // Poll cart while drawer is open (reliable fallback for ReCharge API calls)
    startDrawerPolling();

    // Staggered initial updates
    update();
    setTimeout(update, 1000);
    setTimeout(update, 2500);
  }

  function waitForDrawer() {
    var attempts = 0;
    var iv = setInterval(function() {
      attempts++;
      if (document.querySelector('#cart-drawer')
        || document.querySelector('#recharge-storefront-experiences__cart-drawer')
        || attempts >= 30) {
        clearInterval(iv);
        startMonitoring();
      }
    }, 500);
  }

  // ── Fetch interceptor ───────────────────────────────────────────
  var origFetch = window.fetch;
  window.fetch = function() {
    var url = arguments[0];
    if (typeof url === 'string' && /\/cart\/(add|change|update|clear)/.test(url)) {
      invalidateCache();
      var result = origFetch.apply(this, arguments);
      result.then(function() { setTimeout(update, 150); });
      return result;
    }
    return origFetch.apply(this, arguments);
  };

  // ── XHR interceptor (ReCharge may use XHR instead of fetch) ────
  var origXHROpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function(method, url) {
    if (typeof url === 'string' && /\/cart\/(add|change|update|clear)/.test(url)) {
      this.addEventListener('load', function() {
        invalidateCache();
        setTimeout(update, 150);
      });
    }
    return origXHROpen.apply(this, arguments);
  };

  // ── ReCharge events ─────────────────────────────────────────────
  window.addEventListener('recharge:cart:updated', function() {
    invalidateCache();
    setTimeout(update, 150);
  });
  window.addEventListener('recharge:cart:opened', function() {
    invalidateCache();
    _diagRan = false;
    setTimeout(update, 150);
  });

  // ── Init ────────────────────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForDrawer);
  } else {
    waitForDrawer();
  }
})();
